/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */


(function () {
  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(async (response) => {
      const url = arguments[0];
      // カート操作に関連するURLを検知
      if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {

        // 最新のカート情報を取得
        const cartResponse = await originalFetch('/cart.js');
        const cart = await cartResponse.json();

        // 既存のListenerが反応できるようにイベントを発行
        console.log('Detected Cart Change - Dispatching theme:cart:change');
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));
      }
      return response;
    });
  };

  /**
   * おまけ対象かどうかを判定（10個以上購入で+1おまけキャンペーン）
   * 在庫が quantity + 1 を賄えない場合（在庫ちょうど10個で10個購入など）はおまけ対象外
   * @param {number} quantity - ユーザーが選択した個数
   * @param {boolean} isBulk - 箱買いバリアントかどうか
   * @param {number} [inventory] - 現在の在庫数（不明な場合は在庫チェックをスキップ）
   * @returns {boolean}
   */
  window.shouldApplyBonus = function(quantity, isBulk, inventory) {
    if (isBulk) return false;
    if (quantity < 10) return false;
    if (typeof inventory === 'number' && !isNaN(inventory) && inventory < quantity + 1) return false;
    return true;
  };

  // --- 2. ページ読み込み時（initの代わり）に実行 ---
  document.addEventListener('DOMContentLoaded', async () => {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      bubbles: true,
      detail: {
        cart: cart
      }
    }));
  });
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function (event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    const variant = event.detail.variant;
    const container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });
  console.log("CUSTOMJS")
  document.addEventListener('theme:cart:change', function (event) {
    const cart = event.detail.cart;
    const currentPath = window.location.pathname;
    console.log("CUSTOMJS1")
    if (cart) {
      console.log('Cart ———————————— ↓');
      //console.log(cart);
      if (currentPath === '/cart') return;

      // update sticky cart
      const stickyCart = document.getElementById('sticky-cart');
      if (stickyCart) {
        if (cart.item_count <= 0) {
          stickyCart.style.display = 'none';
          return;
        }

        stickyCart.style.display = 'block';
        const itemsInCart = stickyCart.querySelector('#sticky-cart-items-in-cart');
        const totalPrice = stickyCart.querySelector('#sticky-cart-total-price');

        if (itemsInCart) {
          itemsInCart.dataset.itemsInCart = cart.item_count;
        }
        if (totalPrice) {
          const priceInYen = (cart.total_price / 100).toLocaleString('ja-JP', {
            style: 'currency',
            currency: 'JPY'
          });
          totalPrice.textContent = `${priceInYen}`;
        }
      }
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // --- 合計金額の動的更新 ---
  function getQty(container, sectionId) {
    // free-gacha 等で数量 input が無いテンプレートでは data-fixed-quantity を使用
    const fixed = parseInt(container.dataset.fixedQuantity, 10);
    if (!isNaN(fixed) && fixed > 0) return fixed;
    const quantityInput = document.getElementById('Quantity-' + sectionId);
    return quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
  }

  function initTotalPriceDisplay() {
    document.querySelectorAll('[id^="total-price-display-"]').forEach(function (container) {
      const sectionId = container.dataset.section;
      const totalSpan = document.getElementById('total-price-value-' + sectionId);
      if (!totalSpan) return;

      const quantityInput = document.getElementById('Quantity-' + sectionId);

      function updateTotal() {
        const unitPrice = Math.floor(parseInt(container.dataset.unitPrice, 10) / 100);
        const qty = getQty(container, sectionId);
        totalSpan.textContent = (unitPrice * qty).toLocaleString('ja-JP');
      }

      if (quantityInput) {
        quantityInput.addEventListener('change', updateTotal);
        quantityInput.addEventListener('input', updateTotal);
      }
      updateTotal();
    });
  }

  document.addEventListener('DOMContentLoaded', initTotalPriceDisplay);

  document.addEventListener('theme:variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (!variant) return;

    // quantity のリセット・max 計算は product-info.js の setQuantityBoundries() が担当
    // ここでは合計金額表示の単価更新のみ行う
    document.querySelectorAll('[id^="total-price-display-"]').forEach(function (container) {
      container.dataset.unitPrice = variant.price;
      const sid = container.dataset.section;
      const totalSpan = document.getElementById('total-price-value-' + sid);
      if (!totalSpan) return;
      const unitPrice = Math.floor(variant.price / 100);
      const qty = getQty(container, sid);
      totalSpan.textContent = (unitPrice * qty).toLocaleString('ja-JP');
    });
  });
})();

/**
 * Floating Gacha Button
 * Shows a floating action button when the main buy button scrolls out of view.
 * Replicates the main product form: clear cart → add variant with quantity → checkout.
 */
(function initFloatingGachaButton() {
  const fab = document.getElementById('floating-gacha-button');
  if (!fab) return;

  const sectionId = fab.dataset.sectionId;
  const mode = fab.dataset.mode || 'default';
  const isFreeGacha = mode === 'free-gacha';
  const fabButton = fab.querySelector('button');
  let submitting = false;
  let observer = null;
  let setupTimer = null;

  // Move FAB to body so position:fixed works correctly
  document.body.appendChild(fab);
  fab.style.display = '';

  // --- Helpers: always re-query DOM to avoid stale references ---
  function getSubmitButton() {
    if (isFreeGacha) {
      const fg = document.querySelector('gacha-free-button');
      return fg ? fg.querySelector('button') : null;
    }
    return document.getElementById('ProductSubmitButton-' + sectionId);
  }

  function getFormElements() {
    const productForm = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
    const variantInput = productForm ? productForm.querySelector('.product-variant-id') : null;
    const quantityInput = document.getElementById('Quantity-' + sectionId);
    return {
      variantId: variantInput ? variantInput.value : null,
      quantity: quantityInput ? parseInt(quantityInput.value, 10) : 10,
      isBulk: quantityInput ? quantityInput.dataset.lastVariantBulk === 'true' : false,
      inventory: quantityInput ? parseInt(quantityInput.dataset.inventory, 10) : NaN
    };
  }

  // --- Intersection Observer: toggle visibility ---
  function setupObserver() {
    if (observer) observer.disconnect();

    const btn = getSubmitButton();
    if (!btn) return;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fab.classList.remove('is-visible');
          } else {
            if (entry.boundingClientRect.top < 0) {
              fab.classList.add('is-visible');
            } else {
              fab.classList.remove('is-visible');
            }
          }
        });
      }, {
        threshold: 0
      }
    );
    observer.observe(btn);
  }

  function scheduleObserverSetup() {
    if (setupTimer) clearTimeout(setupTimer);
    setupTimer = setTimeout(setupObserver, 300);
  }

  setupObserver();

  // Re-setup observer when variant changes may replace DOM nodes
  document.addEventListener('theme:variant:change', scheduleObserverSetup);

  // Also detect DOM replacement via MutationObserver on product info container
  const productInfo = document.getElementById('ProductInfo-' + sectionId);
  if (productInfo) {
    new MutationObserver(scheduleObserverSetup)
      .observe(productInfo, {
        childList: true,
        subtree: true
      });
  }

  // --- Reset loading state on bfcache restore (browser back) ---
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      submitting = false;
      fab.classList.remove('is-loading');
    }
  });

  // --- Click handler ---
  fabButton.addEventListener('click', async function () {
    if (submitting) return;

    // For free-gacha template, delegate everything (login check / 1日1回 / 数量10) to gacha-free-button
    if (isFreeGacha) {
      const fg = document.querySelector('gacha-free-button');
      const fgButton = fg ? fg.querySelector('button') : null;
      if (fgButton) fgButton.click();
      return;
    }

    // Re-query all DOM elements fresh (never use cached references)
    const elements = getFormElements();
    if (!elements.variantId) return;

    let quantity = elements.quantity;
    if (isNaN(quantity) || quantity < 1) quantity = 10;

    // Only check disabled attribute (sold out / sale expired)
    // Do NOT check aria-disabled (set transiently by main form during its own submission)
    const currentBtn = getSubmitButton();
    if (currentBtn && currentBtn.disabled) return;

    submitting = true;
    fab.classList.add('is-loading');

    try {
      // 1. Clear cart
      const clearResponse = await fetch('/cart/clear.js', {
        method: 'POST'
      });
      if (!clearResponse.ok) throw new Error('カートのクリアに失敗しました');

      // 2. Add variant with quantity (apply bonus if eligible)
      var isBulk = elements.isBulk || false;
      var actualQuantity = (typeof window.shouldApplyBonus === 'function' && window.shouldApplyBonus(quantity, isBulk, elements.inventory)) ? quantity + 1 : quantity;
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(elements.variantId),
            quantity: actualQuantity
          }]
        })
      });
      const addData = await addResponse.json();
      if (addData.status) throw new Error(addData.description || 'カートへの追加に失敗しました');

      // 3. Redirect to checkout
      window.location.href = '/checkout';
    } catch (error) {
      console.error('Floating gacha button error:', error.message);
      submitting = false;
      fab.classList.remove('is-loading');
    }
  });
})();

// === おまけバッジ・注意書き表示制御 ===
window.updateBonusIndicators = function () {
  document.querySelectorAll('[id^="Quantity-"]').forEach(function (quantityInput) {
    // Extract section ID from input ID (format: "Quantity-{sectionId}")
    var sectionId = quantityInput.id.replace('Quantity-', '');
    var badge = document.getElementById('bonus-badge-' + sectionId);
    var note = document.getElementById('bonus-note-' + sectionId);
    if (!badge && !note) return;

    var qty = parseInt(quantityInput.value, 10) || 0;
    var isBulk = quantityInput.dataset.lastVariantBulk === 'true';
    var noBonus = quantityInput.dataset.noBonus === 'true';
    var inventory = parseInt(quantityInput.dataset.inventory, 10);
    var bonus = !noBonus && window.shouldApplyBonus(qty, isBulk, inventory);

    if (badge) badge.classList.toggle('hidden', !bonus);
    if (note) {
      // 10個以上選択しているのに在庫不足でおまけが付かない場合のみ注意書きを表示
      var showNote = !bonus && !isBulk && qty >= 10 && !isNaN(inventory) && inventory < qty + 1;
      note.classList.toggle('hidden', !showNote);
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="Quantity-"]').forEach(function (quantityInput) {
    quantityInput.addEventListener('change', window.updateBonusIndicators);
    quantityInput.addEventListener('input', window.updateBonusIndicators);
  });
  window.updateBonusIndicators();
});